/** Employee label on Approvals cards/summaries: form field first, then form name. */
export function getFormEmployeeDisplayName(form: {
  name?: string | null;
  fields: Array<{ field: string; value?: string | null }>;
}): string {
  const fromField = form.fields.find((f) => f.field === 'EmployeeName')?.value?.trim();
  if (fromField) return fromField;
  const fromName = form.name?.trim();
  if (fromName) return fromName;
  return 'Unknown';
}
